<template>
  <div class="exchange">
    <div class="container">
      <div class="top">
        <div class="t-left"
          ><span>可用积分：</span><span>{{ integral }}</span></div
        >
        <div class="t-right" @click="bindToShop"
          ><span>积分商城</span><span class="iconfont icon-you"></span
        ></div>
      </div>
      <div class="input-content">
        <van-field
          class="input"
          v-model="order"
          placeholder="请输入来自抖音近三个月的订单号"
          :maxlength="maxlength"
        />
      </div>
      <div class="btn-list">
        <div class="btn-item" @click="bindRecord">转换记录</div>
        <div class="btn-item red-item" @click="bindExchange">一键转换</div>
      </div>
    </div>
    <div class="rule-content">
      <img
        class="rule-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9fcc3ac6d9f0db52c9f1bfd99370d7de.jpg"
        alt=""
      />
    </div>
    <van-overlay :show="showToast" @click="showToast = false">
      <div class="wrapper" @click.stop>
        <SuccessToast
          v-if="toastStatus == 1"
          :options="toastOptions"
          @confirm="bindToShop"
          @cancel="bindConfirm"
        />
        <FailToast
          v-if="toastStatus == 0"
          :options="toastOptions"
          @confirm="bindConfirm"
          @cancel="bindCancel"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import SuccessToast from './components/toast.vue'
import FailToast from './components/fail-toast.vue'
export default {
  name: 'dounyin-integral-exchange-exchange',
  components: {
    SuccessToast,
    AppNavbar,
    FailToast
  },
  data() {
    return {
      integral: 0,
      maxlength: 19,
      order: '',
      showToast: false,
      toastOptions: {},
      toastStatus: 1
    }
  },
  watch: {
    $route(to, from) {
      if (
        from.path == '/integral-exchange/index' &&
        to.path == '/integral-exchange/exchange'
      ) {
        this.getIntegral()
        this.order = ''
      }
      if (
        from.path == '/integral-exchange/login' &&
        to.path == '/integral-exchange/exchange' &&
        sessionStorage.getItem('dy-integral-exchange-login')
      ) {
        this.getIntegral()
      }
    }
  },
  activated() {
    this.$http.bindPageUMA()
  },
  created() {
    this.checkLogin()
    this.getIntegral()
  },
  methods: {
    checkLogin() {
      this.gym_code = this.$http._getCookie('token')
      if (!this.gym_code && !this.$route.query.refresh) {
        let url = location.href
        let params = url.includes('?') ? '&refresh=1' : '?refresh=1'
        url = url + params
        location.href =
          'http://auth3.gymcity.com.cn/?auth=wegymer&scope=snsapi_userinfo&next=' +
          encodeURIComponent(url)
      }
    },
    getIntegral() {
      let params = {
        token: this.$http._getCookie('dy-integral-token')
      }
      this.$http
        .getApp('api/v1/IntegralConversionCenter/getUserIntegral', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.integral = res.data?.integral || 0
          } else if (res.code == 401) {
            this.$toast('请登录')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindExchange() {
      if (!this.order) {
        this.$toast('订单号不能为空')
        return
      }
      let reg = /\d{19}/
      if (!reg.test(this.order)) {
        this.$toast('订单号格式不正确，请输入正确的订单号')
        return
      }
      let params = {
        order_id: this.order,
        token: this.$http._getCookie('dy-integral-token')
      }
      this.$http
        .postApp('api/v1/IntegralConversionCenter/convertIntegral', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.toastStatus = 1
            this.toastOptions = res.data
            this.showToast = true
            this.order = ''
            this.getIntegral()
          } else if (res.code == 401) {
            this.$toast('请登录')
          } else {
            this.toastStatus = 0
            this.toastOptions = { message: res.msg }
            this.showToast = true
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    bindToShop() {
      location.href =
        'https://187447846.cms.n.weimob.com/bos/cms/187447846/0/2583566846/design/design?pageid=71785903846'
    },
    bindConfirm() {
      this.showToast = false
    },
    bindCancel() {
      this.bindToShop()
    },
    bindRecord() {
      this.$router.push('/integral-exchange/record')
    }
  }
}
</script>
<style lang="scss" scoped>
.exchange {
  min-height: 100vh;
  background-color: #f9f9f9;

  .container {
    padding: 20px 16px 30px;
    background: #ffffff;

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 19px;

      .t-left {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 10px;
      }

      .t-right {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6988ff;
        line-height: 20px;

        .iconfont {
          margin-left: 4px;
        }
      }
    }

    .input-content {
      margin-bottom: 20px;
      height: 50px;
      background: rgba(241, 241, 243, 0.8);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      ::v-deep .van-cell {
        background-color: transparent;
      }
    }

    .btn-list {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn-item {
        text-align: center;
        width: 162px;
        height: 44px;
        box-sizing: border-box;
        border-radius: 22px;
        border: 1px solid rgba(250, 44, 25, 0.3);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fa2c19;
        line-height: 44px;
      }

      .red-item {
        background: #fa2c19;
        color: #fff;
      }
    }
  }

  .wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .rule-content {
    .rule-image {
      width: 100%;
    }
  }
}
</style>
